
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IProduct } from '@homeserve/od-typings/api';

@Component
export default class WLListItem extends Vue {
  @Prop()
  private product!: Partial<IProduct>;

  get productDisplayName() {
    return this.product.seoTitle || this.product.name;
  }
}
